import { datadogLogs } from "@datadog/browser-logs";
import cookie from "js-cookie";

export const initDatadogLogs = (): void => {
  const isProd = process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT === "production";
  const isDatadogEnabled = cookie.get("datadog_logs") === "true";

  if (isProd || isDatadogEnabled) {
    datadogLogs.init({
      service: "frontend-browser",
      site: "datadoghq.eu",
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || "",
      version: `v:${process.env.NEXT_PUBLIC_GIT_COMMIT_SHA}`, // (dd tags must start with a letter)
      env: process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT,
      /* -------------------------- CONFIGURATION OPTIONS ------------------------- */
      sessionSampleRate: 100,
      // [forwardErrorsToLogs] DEFAULT: Set to false to stop forwarding console.error logs, uncaught exceptions and network errors to Datadog.
      forwardErrorsToLogs: true
    });
  }
};
